import { Directive } from '@angular/core';

/** The floating label for a `app-form-field`. */
@Directive({
   
  selector: 'app-form-label',
  standalone: true,
})
export class FormFieldLabelDirective {}
